/**
 * Fetch Interceptor - Logs all API requests with timing information to the console
 * Gets attached to window.fetch automatically on import
 */

export function initializeFetchInterceptor() {
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const [resource, config] = args;
    const url = typeof resource === 'string' ? resource : resource.url;
    const method = (config?.method || 'GET').toUpperCase();
    const requestId = Math.random().toString(36).substr(2, 9);
    const startTime = performance.now();

    // Log request start
    console.log(
      `%c[${requestId}] ${method} ${url}`,
      'color: #0066cc; font-weight: bold;'
    );

    return originalFetch.apply(this, args)
      .then((response) => {
        const duration = (performance.now() - startTime).toFixed(2);
        const status = response.status;
        const statusColor = status >= 200 && status < 300 ? '#00aa00' : status >= 400 ? '#ff0000' : '#ff8800';

        console.log(
          `%c✓ [${requestId}] ${method} ${url} - ${status} (${duration}ms)`,
          `color: ${statusColor}; font-weight: bold;`
        );

        return response;
      })
      .catch((error) => {
        const duration = (performance.now() - startTime).toFixed(2);
        console.log(
          `%c✗ [${requestId}] ${method} ${url} - ERROR (${duration}ms)`,
          'color: #ff0000; font-weight: bold;'
        );
        console.error(`  Error: ${error.message}`);
        throw error;
      });
  };

  console.log('%c📊 Request timing interceptor initialized', 'color: #6600cc; font-weight: bold; font-size: 12px;');
}
